export default function PHP_if() {
  return (
    <div>
      <h1>PHP_if</h1>
    </div>
  );
}
